import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c164555e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "task__popover-title"
}
const _hoisted_2 = {
  key: 1,
  class: "task__popover-title-empty-value"
}
const _hoisted_3 = {
  key: 1,
  class: "absence-value"
}

import { TaskModel } from '@/components/tasks-kanban/models';
import { ListItemModel } from '../../../models';
import { PropType, ref } from 'vue';
import { TaskCardItemWrapper } from './';
import { FlagIcon } from 'tir-style-system/icons/solid';
import {
  PopoverColorEnum,
  PopoverPositionEnum,
  TirPmPopover,
  TirPmTooltipElement,
} from 'tir-components';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-card-priority',
  props: {
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TaskCardItemWrapper), { element: __props.element }, {
    default: _withCtx(() => [
      (__props.task.Priority?.Id)
        ? (_openBlock(), _createBlock(_unref(TirPmTooltipElement), { key: 0 }, {
            content: _withCtx(() => [
              (props.task.Priority.Name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(props.task.Priority.Name), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_2, "-"))
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(FlagIcon), {
                class: "task-card_icon",
                style: _normalizeStyle({ color: __props.task.Priority.Color })
              }, null, 8, ["style"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("p", _hoisted_3, "-"))
    ]),
    _: 1
  }, 8, ["element"]))
}
}

})